import { Image } from 'antd';
import React, { useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Slider from 'react-slick';
import styles from './index.module.scss';

type ProductInfoProps = {
  id?: string;
  productLogo?: string;
  productName?: string;
  productDesc?: string;
  companyName?: string;
  companyAddress?: string;
  companyFinancing?: string;
  companyEstablishedTime?: string;
  imgUrlList?: string[];
};

const PrevArrow = props => {
  const { onClick } = props;
  return (
    <div className={styles.prevArrowWrapper} onClick={onClick}>
      <svg className="icon" aria-hidden="true">
        <use xlinkHref="#icon-product_img_slick_arrow_left" />
      </svg>
    </div>
  );
};
const NextArrow = props => {
  const { onClick } = props;
  return (
    <div className={styles.nextArrowWrapper} onClick={onClick}>
      <svg className="icon" aria-hidden="true">
        <use xlinkHref="#icon-product_img_slick_arrow_right" />
      </svg>
    </div>
  );
};
const settings = {
  infinite: true,
  speed: 500,
  slidesToScroll: 1,
  prevArrow: <PrevArrow />,
  nextArrow: <NextArrow />,
};

const ProductInfo: React.FC<ProductInfoProps> = ({
  id = 'productInfo',
  productDesc,
  companyName,
  companyAddress,
  companyFinancing,
  companyEstablishedTime,
  imgUrlList,
}) => {
  const [visible, setVisible] = useState(false);
  const [current, setCurrent] = useState(0);
  return (
    <section className={styles.section}>
      <h2 id={id} className={styles.title}>
        产品信息
      </h2>
      <div className={styles.infoRow} style={{ marginTop: 24 }}>
        <div>
          <h3 className={styles.subTitle}>产品描述</h3>
          <p className={styles.productDesc}>{productDesc}</p>
        </div>
      </div>
      <div className={styles.infoRow}>
        <div className={styles.infoColumn}>
          <h3 className={styles.subTitle}>公司名称</h3>
          <p>{companyName || '-'}</p>
        </div>
        <div className={styles.infoColumn}>
          <h3 className={styles.subTitle}>成立时间</h3>
          <p>{companyEstablishedTime || '-'}</p>
        </div>
      </div>
      <div className={styles.infoRow}>
        <div className={styles.infoColumn}>
          <h3 className={styles.subTitle}>公司地址</h3>
          <p>{companyAddress || '-'}</p>
        </div>
        {!!companyFinancing && (
          <div className={styles.infoColumn}>
            <h3 className={styles.subTitle}>当前融资</h3>
            <p>{companyFinancing || '无'}</p>
          </div>
        )}
      </div>
      {imgUrlList?.length && (
        <>
          <div className={styles.infoRow}>
            <h3 className={styles.subTitle}>产品截图</h3>
            <p className={styles.subTitle}>共{imgUrlList.length}张</p>
          </div>
          <Slider
            {...settings}
            slidesToShow={imgUrlList.length >= 3 ? 3 : imgUrlList.length}
            className={imgUrlList.length >= 3 ? styles.multipleSlide : styles.slide}
          >
            {imgUrlList.map((item, index) => (
              <LazyLoadImage
                key={index}
                src={item}
                width="285"
                height="160"
                placeholderSrc="//images.dtcj.com/cbndata/icon/loading.gif"
                wrapperClassName={styles.productImgWrapper}
                onClick={() => {
                  setVisible(true);
                  setCurrent(index);
                }}
              />
            ))}
          </Slider>
          <div style={{ display: 'none' }}>
            <Image.PreviewGroup preview={{ visible, current, onVisibleChange: vis => setVisible(vis) }}>
              {imgUrlList.map((item, index) => (
                <Image key={index} src={item} placeholder="//images.dtcj.com/cbndata/icon/loading.gif" />
              ))}
            </Image.PreviewGroup>
          </div>
        </>
      )}
    </section>
  );
};
export default ProductInfo;
